/* eslint-disable jsx-a11y/no-autofocus */
import React, { useEffect, useRef, useState } from 'react'
import { useTransition, animated } from 'react-spring'

//Components
import OTPTimer from '../../../components/OTPTimer'
import WrapperButton from '../../../components/WrapperButton'

//Types
import { InputTypes, OTPVerificationType } from '../../../types/components'
import { APIMethods, ReqBodyWithHeaders, ViewTypes } from '../../../types/state'

//Redux
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../redux/store'
import { authenticateUser } from '../../../redux/slices/user'
import { setErrorStatus, updateView } from '../../../redux/slices/meta'

//Helpers
import { endPoints, GA } from '../../../constants'
import { setWindowGA } from '../../../helpers/DTM'
import { setErrorToast } from '../../../helpers/errorStyles'

//Styles
import {
	ColorSpan,
	OTPInput,
	OTPInputWrapper,
	OTPVerificationWrapper,
	OTPWrapper,
	Heading,
} from './styles'

//Icons
import editIcon from '../../../asset/edit.png'

const OTPVerification = ({ whatsAppChecked }: OTPVerificationType) => {
	const dispatch = useDispatch()

	const userDetails = useSelector((state: RootState) => state.user)
	const metaData = useSelector((state: RootState) => state.meta)
	const translations = useSelector(
		(state: RootState) => state.translations.data
	)

	const [isEnabled, setIsEnabled] = useState(false)
	const [otpValues, setOtpValues] = useState<string[]>(['', '', '', ''])
	const [isLoaded, setIsLoaded] = useState(false)
	const transition = useTransition(isLoaded, {
		from: { opacity: 0, transform: 'translateX(-20px)', delay: 100 },
		enter: { opacity: 1, transform: 'translateX(0)', delay: 100 },
		leave: { opacity: 0, transform: 'translateX(20px)', delay: 100 },
	})

	const input1Ref = useRef(null)
	const input2Ref = useRef(null)
	const input3Ref = useRef(null)
	const input4Ref = useRef(null)
	useEffect(() => {
		setIsLoaded(true)
	}, [])

	useEffect(() => {
		if (metaData.isError) {
			setErrorToast(metaData.errorMessage)
			dispatch(setErrorStatus({ status: false, message: '' }))
		}
	}, [metaData.isError, metaData.errorMessage, dispatch])

	const onNavigateClick = (val = '') => {
		const data = {
			event: GA.eventName,
			pageName: GA.verifyOtpPage,
			pageURL: window.location.href,
			loginStatus: metaData.isLogin,
			platform: metaData.platform,
		}
		setWindowGA(data)

		const reqObj: ReqBodyWithHeaders = {
			url: endPoints.authenticateUser,
			method: APIMethods.POST,
			code: val !== '' ? otpValues.join('') + val : otpValues.join(''),
			phoneCode: '+91',
			telephone: userDetails.phone,
			sessionId: userDetails.sessionId,
			client: metaData.deviceType,
			whatsAppChecked: whatsAppChecked,
		}
		dispatch(authenticateUser(reqObj))
	}

	const onBackClick = () => {
		dispatch(updateView(ViewTypes.LOGIN))
	}

	const updateOTPValue = (
		index: number,
		e: React.ChangeEvent<HTMLInputElement>,
		nextRef: any,
		currRef: any,
		isSubmit: boolean
	) => {
		if (e.target.value.length <= 1) {
			let count = 0
			const newOTPValues = [...otpValues]
			newOTPValues[index] = e.target.value
			newOTPValues.map((item) => {
				if (item !== '') {
					count += 1
				}
			})
			if (count === 4) {
				setIsEnabled(true)
			} else {
				setIsEnabled(false)
			}
			setOtpValues(newOTPValues)
			if (currRef !== null) {
				if (e.target.value.length === 0) {
					currRef.current.focus()
				}
			}

			if (nextRef !== null) {
				if (e.target.value.length === 1) {
					nextRef.current.focus()
				}
			}

			if (isSubmit && currRef.current.value !== '') {
				onNavigateClick(currRef.current.value)
			}
		}
	}

	return (
		<>
			{transition((style, item) =>
				item ? (
					<animated.div style={style}>
						<Heading>{translations.OTP_TEXT}</Heading>
						<OTPVerificationWrapper device={metaData.deviceType}>
							<OTPWrapper>
								<OTPInputWrapper>
									<OTPInput
										autoFocus={true}
										autoComplete={translations.ONE_TIME_CODE}
										inputMode="numeric"
										type={InputTypes.NUMBER}
										maxLength={1}
										value={otpValues[0]}
										ref={input1Ref}
										onChange={(e) =>
											updateOTPValue(
												0,
												e,
												input2Ref,
												input1Ref,
												false
											)
										}
									/>
									<OTPInput
										autoComplete={translations.ONE_TIME_CODE}
										inputMode="numeric"
										type={InputTypes.NUMBER}
										maxLength={1}
										value={otpValues[1]}
										ref={input2Ref}
										onChange={(e) =>
											updateOTPValue(
												1,
												e,
												input3Ref,
												input2Ref,
												false
											)
										}
									/>
									<OTPInput
										autoComplete={translations.ONE_TIME_CODE}
										inputMode="numeric"
										type={InputTypes.NUMBER}
										maxLength={1}
										value={otpValues[2]}
										ref={input3Ref}
										onChange={(e) =>
											updateOTPValue(
												2,
												e,
												input4Ref,
												input3Ref,
												false
											)
										}
									/>
									<OTPInput
										autoComplete={translations.ONE_TIME_CODE}
										inputMode="numeric"
										type={InputTypes.NUMBER}
										maxLength={1}
										value={otpValues[3]}
										ref={input4Ref}
										onChange={(e) =>
											updateOTPValue(3, e, null, input4Ref, true)
										}
									/>
								</OTPInputWrapper>
								<OTPTimer />
								<ColorSpan onClick={onBackClick}>
									<img
										src={editIcon}
										alt={translations.PHONE_EDIT_ALT}
									/>{' '}
									&nbsp; +91
									{userDetails.phone}
								</ColorSpan>
							</OTPWrapper>
							<WrapperButton
								isLoading={metaData.isLoading}
								isEnabled={isEnabled}
								btnText={translations.NEXT}
								buttonClickHandler={onNavigateClick}
							/>
						</OTPVerificationWrapper>
					</animated.div>
				) : (
					''
				)
			)}
		</>
	)
}

export default OTPVerification
